import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import 'react-datepicker/dist/react-datepicker.css'

import HereMap from "../../components/Map/HereMap"
import { Row, Column } from "../../components/Layout"
import LogView from "../../components/EventLog/LogView";
import TrackerLogItem from "../../components/EventLog/TrackerLogItem";
import { pinIcons } from "img/icons"
import style from "./tracker.module.scss"

import { getPositions } from "redux/tracker/trackerActions";


export default function TrackerDevicePage() {
	
	const { deviceid } = useParams()
	const dispatch = useDispatch();
	const trackerStatus = useSelector(store => store.tracker.status)
	const trackerPositions = useSelector(store => store.tracker.devices)

	const [state, setState] = useState({
		zoom: 10,
		startDate: null,
		endDate: null,
		scroll_step: 10,
		scroll_limit: 10,
		scroll_hasMore: true,
		scroll_items: [],
		interval: "daily"
	})

	useEffect(() => {
		let params = { millis: moment().valueOf(), day: 1 }
		dispatch(getPositions(deviceid, params))
	}, [deviceid, dispatch])

	const devicePopUp = useCallback((name, ts, type) => (
		`<div class="bubble">
			<div class="name">stato</div><div>${type}</div>
			<div class="name">ultimo contatto</div><div>${moment(ts).format("DD-MM-YYYY HH:mm")}</div>
		</div>`
	), [])

	const getIcon = useCallback((type="") => {
		if(type.toLowerCase().includes("start")) {
			return pinIcons.start
		} else if(type.toLowerCase().includes("stop")) {
			return pinIcons.stop
		} else if(type.toLowerCase().includes("move")) {
			return pinIcons.move
		} else if(type.toLowerCase().includes("keep alive") || type.toLowerCase().includes("keepalive")) {
			return pinIcons.stillAlive
		} else if(type.toLowerCase().includes("sensor")) {
			return pinIcons.sensor
		} else if(type.toLowerCase().includes("deactivated track") || type.toLowerCase().includes("deactivatedtrack")) { // deve precedere "activated track"
			return pinIcons.off
		} else if(type.toLowerCase().includes("activated track") || type.toLowerCase().includes("activatedtrack")) {
			return pinIcons.on
		} else if(type.toLowerCase().includes("close")) {
			return pinIcons.close
		} else if(type.toLowerCase().includes("open")) {
			return pinIcons.open
		} else return pinIcons.alert
	}, [])

	const centerMap = useCallback((lat, lng) => {
		setState(state => ({ ...state, center: { lat, lng }, zoom: 11, selected: { lat, lng } }))
	}, [])

	const infoCell = useCallback((name, value) => (
		<Row>
			<Column style={{padding:10}}>
				<div className={style.title}>{name}</div>
				<div className={style.underlined}>{value}</div>
			</Column>
		</Row>
	), [])

	const [positions, markers] = useMemo(() => {
		let positions = trackerPositions[deviceid] || [];
		let markers = positions.filter(p => p.lat).map(p => { return {
			lat: p.lat,
			lng: p.lng,
			ts: p.timestamp,
			data: devicePopUp(deviceid, p.timestamp, p.messageType),
			icon: getIcon(p.messageType)
		}})
		if (markers && markers.length > 0) {
			markers.sort((a, b) => a.ts - b.ts)
		}
		return [positions, markers]
	}, [trackerPositions, deviceid, devicePopUp, getIcon])

	useEffect(() => {
		if (markers && markers.length > 0)
			centerMap(markers[0].lat, markers[0].lng)
	}, [markers, centerMap])
	
	let status = trackerStatus.find(s => s.deviceId === deviceid);

	return (
		<div className="animated fadeIn">
			<Row className={style.box}>
				<Column>
					<HereMap
						center={state.center}
						zoom={state.zoom}
						theme={"normal.day"}
						markers={markers}
						route={true}
						className={style.map}
						selected={state.selected}
					/>

					{ status &&
					<Row style={{padding:20}}>
						<Column>
							{infoCell("label", status.label)}
							{infoCell("ultimo contatto", status.timestamp)}
						</Column>
						<Column>
							{infoCell("temperatura", status.temperature +"°")}
							{infoCell("batteria", status.bat + "%")}
						</Column>
						<Column/>
					</Row>
					}

				</Column>
				<Column style={{padding:10, maxWidth:"38rem"}}>
					<LogView
						getItem={(i,p,data) => <TrackerLogItem
							key={i.timestamp}
							item={i}
							pos={p}
							data={data}
							elements={positions}
							onClick={() => i.lat && i.lng && centerMap(i.lat, i.lng)}
							getIcon={getIcon}
							/>}
						getElements={params => dispatch(getPositions(deviceid, params))}
						elements={positions}
						getIcon={getIcon}
					/>
				</Column>
			</Row>
		</div>
	)
}
